export function upgrade(userSettings) {

  const {welcomeBannerSeen} = userSettings

  if (!welcomeBannerSeen) {
    return userSettings
  }

  delete userSettings.welcomeBannerSeen

  userSettings.trialActivatedMessageSeen = welcomeBannerSeen
}

export const DEFAULT_SETTINGS = {
  trialActivatedMessageSeen: false,
  isLiked: false,
  isQuickMenuShown: false,
  tips: {
    version: 0
  },
  favorites: {
    fonts: [],
    colors: []
  },
  preferences: {
    autoConfirmSwapVideo: false
  },
  newFeatures: {
    'character-builder': {
      dismissedTimestamp: undefined,
      viewState: 'new'
    }
  }
}